import { useState } from "react";
import { supabase } from "../config/supabaseClient";
import { useAuth } from "../context/AuthContext";
import { ORASE, RASE_CAINE, RASE_PISICA, CULORI } from "../data/optiuniAnunt";
import "./FormularAnunt.css";

export default function FormularAnunt({ tip, onSuccess }) {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [imagini, setImagini] = useState([]);
  const [preview, setPreview] = useState([]);
  const [form, setForm] = useState({
    specie: "",
    rasa: "",
    sex: "",
    culoare: "",
    oras: "",
    telefon: "",
    email: user?.email || "",
    detalii: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
      // resetează rasa când schimbi specia
      ...(name === "specie" ? { rasa: "" } : {}),
    }));
  };

  const handleImagini = (e) => {
    const files = Array.from(e.target.files);
    setImagini(files);
    setPreview(files.map((f) => URL.createObjectURL(f)));
  };

  const uploadImagini = async () => {
    const urls = [];
    for (const file of imagini) {
      const nume = `${user.id}/${Date.now()}_${file.name}`;
      const { error } = await supabase.storage
        .from("animale")
        .upload(nume, file);
      if (!error) {
        const { data } = supabase.storage.from("animale").getPublicUrl(nume);
        urls.push(data.publicUrl);
      }
    }
    return urls;
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const urlImagini = await uploadImagini();

    const { data, error } = await supabase
      .from("anunturi")
      .insert({
        ...form,
        tip,
        user_id: user.id,
        imagini: urlImagini,
      })
      .select()
      .single();

    if (error) throw error;

    // Indexează în AI — automat la fiecare postare nouă
    if (urlImagini.length > 0 && process.env.REACT_APP_AI_SERVICE_URL) {
      try {
        const imgResponse = await fetch(urlImagini[0]);
        const blob = await imgResponse.blob();

        const formData = new FormData();
        formData.append("file", blob, "image.jpg");
        formData.append("anunt_id", data.id);
        formData.append("tip", tip);

        const aiRes = await fetch(
          `${process.env.REACT_APP_AI_SERVICE_URL}/index`,
          { method: "POST", body: formData }
        );

        if (aiRes.ok) {
          console.log("✅ Imagine indexată în AI");
        }
      } catch (aiErr) {
        console.log("⚠️ AI indexing skip:", aiErr.message);
      }
    }

    alert("Anunț postat cu succes! ✅");
    onSuccess();
  } catch (err) {
    console.error(err);
    alert("Eroare la postare: " + err.message);
  } finally {
    setLoading(false);
  }
};

  const rase = form.specie === "caine" ? RASE_CAINE : RASE_PISICA;

  return (
    <form className="formular-anunt" onSubmit={handleSubmit}>
      {/* <h2>
        {tip === "gasit" ? "Anunț animal găsit" : "Anunț animal pierdut"}
      </h2> */}

      {/* Upload imagini */}
      <div className="form-group">
        <label>Fotografii animal *</label>
        <input
          type="file"
          accept="image/*"
          multiple
          onChange={handleImagini}
          required
        />
        {preview.length > 0 && (
          <div className="preview-imagini">
            {preview.map((src, i) => (
              <img key={i} src={src} alt={`preview ${i}`} />
            ))}
          </div>
        )}
      </div>

      {/* Specie */}
      <div className="form-group">
        <label>Specie *</label>
        <select name="specie" value={form.specie} onChange={handleChange} required>
          <option value="">Selectează specia</option>
          <option value="caine">Câine</option>
          <option value="pisica">Pisică</option>
        </select>
      </div>

      {/* Rasă */}
      {form.specie && (
        <div className="form-group">
          <label>Rasă *</label>
          <select name="rasa" value={form.rasa} onChange={handleChange} required>
            <option value="">Selectează rasa</option>
            {rase.map((r) => (
              <option key={r} value={r}>{r}</option>
            ))}
          </select>
        </div>
      )}

      {/* Sex */}
      <div className="form-group">
        <label>Sex</label>
        <select name="sex" value={form.sex} onChange={handleChange}>
          <option value="">Necunoscut</option>
          <option value="mascul">Mascul</option>
          <option value="femela">Femelă</option>
        </select>
      </div>

      {/* Culoare */}
      <div className="form-group">
        <label>Culoare *</label>
        <select name="culoare" value={form.culoare} onChange={handleChange} required>
          <option value="">Selectează culoarea</option>
          {CULORI.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
      </div>

      {/* Oraș */}
      <div className="form-group">
        <label>Oraș *</label>
        <select name="oras" value={form.oras} onChange={handleChange} required>
          <option value="">Selectează orașul</option>
          {ORASE.map((o) => (
            <option key={o} value={o}>{o}</option>
          ))}
        </select>
      </div>

      {/* Telefon */}
      <div className="form-group">
        <label>Număr de telefon *</label>
        <input
          type="tel"
          name="telefon"
          value={form.telefon}
          onChange={handleChange}
          placeholder="07xx xxx xxx"
          required
        />
      </div>

      {/* Email */}
      <div className="form-group">
        <label>Email de contact</label>
        <input
          type="email"
          name="email"
          value={form.email}
          onChange={handleChange}
          placeholder="email@exemplu.ro"
        />
      </div>

      {/* Detalii */}
      <div className="form-group">
        <label>Detalii suplimentare</label>
        <textarea
          name="detalii"
          value={form.detalii}
          onChange={handleChange}
          placeholder="Descrie animalul, locul unde l-ai găsit/pierdut..."
          rows={4}
        />
      </div>

      <button type="submit" className="btn-submit" disabled={loading}>
        {loading ? "Se postează..." : "Publică anunțul"}
      </button>
    </form>
  );
}